/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_TemplateInputs */

const en_resume_editor_template = /** @type {(inputs: Resume_Editor_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template`)
};

const de_resume_editor_template = /** @type {(inputs: Resume_Editor_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage`)
};

const fr_resume_editor_template = /** @type {(inputs: Resume_Editor_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modele`)
};

const es_resume_editor_template = /** @type {(inputs: Resume_Editor_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantilla`)
};

const it_resume_editor_template = /** @type {(inputs: Resume_Editor_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modello`)
};

const nl_resume_editor_template = /** @type {(inputs: Resume_Editor_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjabloon`)
};

const pl_resume_editor_template = /** @type {(inputs: Resume_Editor_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szablon`)
};

const fi_resume_editor_template = /** @type {(inputs: Resume_Editor_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malli`)
};

const da_resume_editor_template = /** @type {(inputs: Resume_Editor_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skabelon`)
};

const sv_resume_editor_template = /** @type {(inputs: Resume_Editor_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mall`)
};

/**
* | output |
* | --- |
* | "Template" |
*
* @param {Resume_Editor_TemplateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_template = /** @type {((inputs?: Resume_Editor_TemplateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_TemplateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_template(inputs)
	if (locale === "fr") return fr_resume_editor_template(inputs)
	if (locale === "es") return es_resume_editor_template(inputs)
	if (locale === "it") return it_resume_editor_template(inputs)
	if (locale === "nl") return nl_resume_editor_template(inputs)
	if (locale === "pl") return pl_resume_editor_template(inputs)
	if (locale === "fi") return fi_resume_editor_template(inputs)
	if (locale === "da") return da_resume_editor_template(inputs)
	if (locale === "sv") return sv_resume_editor_template(inputs)
	return en_resume_editor_template(inputs)
});